import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Paper from '@material-ui/core/Paper';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link'
import Copyright from '../Copyright';
import Biography from './Biography';
import Attributes from './Attributes';
import Skills from './Skills';
import Disciplines from './Disciplines';
import Traits from './Traits';
import CharacterNotes from './CharacterNotes';
import BloodPotency from './BloodPotency';
import Review from './Review';


const useStyles = makeStyles((theme) => ({
  appBar: {
    position: 'relative',
  },
  layout: {
    width: 'auto',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(900 + theme.spacing(2) * 2)]: {
      width: 900,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(900 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3),
    },
  },
  stepper: {
    padding: theme.spacing(3, 0, 5),
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
}));

const steps = [
        'Bio', 
        'Attributes', 
        'Skills', 
        'Disciplines', 
        'Traits', 
        'Notes',
        'Potency', 
        'Review'];

function getStepContent(step) {
  switch (step) {
    case 0:
      return <Biography />;
    case 1:
      return <Attributes />;
    case 2:
      return <Skills />;
    case 3:
      return <Disciplines />;
    case 4:
      return <Traits />;
    case 5:
      return <CharacterNotes />;
    case 6:
      return <BloodPotency />;
    case 7:
      return <Review />;
    default:
      throw new Error('Unknown step');
  }
}

export default function CharacterCreation() {
  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);

  const handleNext = () => {
    setActiveStep(activeStep + 1);
  };

  const handleBack = () => {
    setActiveStep(activeStep - 1);
  };

  return (
    <React.Fragment>
      <CssBaseline />
      <AppBar position="absolute" color="secondary" className={classes.appBar}>
        <Toolbar>
        <Typography variant="h6" color="inherit" noWrap>
            <Link href="/" color="inherit">
              Kindred: the Companion App
            </Link>
          </Typography>
        </Toolbar>
      </AppBar>
      <main className={classes.layout}>
        <Paper className={classes.paper}>
          <Typography component="h1" variant="h4" align="center">
            Character Creation
          </Typography>
          <Stepper activeStep={activeStep} className={classes.stepper}>
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
          <React.Fragment>
            {activeStep === steps.length ? (
              <React.Fragment>
                <Typography variant="h5" gutterBottom>
                  Have a splendid campaign!
                </Typography>
                <Typography variant="subtitle1">
                  Your new character sheet has been saved and stored in your account.  Simply find the card with your new character and either click view to see your character sheet or click edit to make changes.
                </Typography>
                <Button
                    variant="contained"
                    color="secondary"
                    href="/"
                    className={classes.button}
                  >
                    Back to Home
                  </Button>
              </React.Fragment>
            ) : (
              <React.Fragment>
                {getStepContent(activeStep)}
                <div className={classes.buttons}>
                  {activeStep !== 0 && (
                    <Button onClick={handleBack} className={classes.button}>
                      Back
                    </Button>
                  )}
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={handleNext}
                    className={classes.button}
                  >
                    {activeStep === steps.length - 1 ? 'Save character' : 'Next'}
                  </Button>
                </div>
              </React.Fragment>
            )}
          </React.Fragment>
        </Paper>
        <Copyright />
      </main>
    </React.Fragment>
  );
}